export const WAS_FOREIGN_OPTIONS = {
  en: [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ],
  es: [
    { label: 'Sí', value: true },
    { label: 'No', value: false },
  ],
};
